import type { FC } from 'react';
import { Skeleton } from '@chakra-ui/react';
import type { SkeletonProps } from '@chakra-ui/react';

export const MyAccountSkeleton: FC<SkeletonProps> = (props) => (
    <div className="flex h-full w-full" data-testid="my-account-skeleton">
        <div className="grid flex-1 grid-cols-1 gap-y-4 p-4 sm:grid-cols-2 sm:gap-4 md:grid-cols-3 md:grid-rows-[repeat(4,min-content)]">
            <Skeleton
                {...props}
                className="row-span-4 hidden md:block"
                height="100%"
                width="100%"
                rounded="none"
            />
            <Skeleton
                {...props}
                className="col-span-1 sm:col-span-2"
                aspectRatio={1150 / 300}
                width="100%"
                rounded="none"
            />
            <Skeleton {...props} height="40px" width="100%" rounded="none" />
            <Skeleton {...props} height="20px" width="100%" rounded="none" />
            <Skeleton
                {...props}
                className="aspect-square"
                height="100%"
                width="100%"
                rounded="none"
            />
            <Skeleton
                {...props}
                className="aspect-square"
                height="100%"
                width="100%"
                rounded="none"
            />
            <Skeleton
                {...props}
                className="aspect-square"
                height="100%"
                width="100%"
                rounded="none"
            />
            <Skeleton
                {...props}
                className="aspect-square"
                height="100%"
                width="100%"
                rounded="none"
            />
        </div>
    </div>
);
